<dt-table-layout *dtDataLoad="true; error: hasError" [isLoading]="isLoading">
  <div header class="header">
    <form class="filters-form" [formGroup]="filterForm" (ngSubmit)="triggerLoadSubject.next()">
      <mat-form-field subscriptSizing="dynamic">
        <mat-label i18n>Abgeschlossen</mat-label>
        <mat-select formControlName="finished">
          <mat-option [value]="null" i18n>Egal</mat-option>
          <mat-option [value]="true" i18n>Ja</mat-option>
          <mat-option [value]="false" i18n>Nein</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field subscriptSizing="dynamic">
        <mat-label i18n>Offizielles Projekt</mat-label>
        <mat-select formControlName="isOfficial">
          <mat-option [value]="null" i18n>Egal</mat-option>
          <mat-option [value]="true" i18n>Ja</mat-option>
          <mat-option [value]="false" i18n>Nein</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field subscriptSizing="dynamic">
        <mat-label i18n>Zeitspanne</mat-label>
        <mat-date-range-input
          [formGroup]="filterForm.controls.dateRange"
          [rangePicker]="dateRangePicker"
          [comparisonStart]="filterForm.value.dateRange.start"
          [comparisonEnd]="filterForm.value.dateRange.end"
        >
          <input matStartDate i18n-placeholder placeholder="Startdatum" formControlName="start" readonly />
          <input matEndDate i18n-placeholder placeholder="Enddatum" formControlName="end" readonly />
        </mat-date-range-input>
        @if (!filterForm.controls.dateRange.pristine) {
          <button matSuffix mat-icon-button (click)="filterForm.controls.dateRange.reset()">
            <mat-icon>close</mat-icon>
          </button>
        }
        <mat-datepicker-toggle matSuffix [for]="dateRangePicker"></mat-datepicker-toggle>
        <mat-date-range-picker #dateRangePicker></mat-date-range-picker>
      </mat-form-field>
    </form>

    <div class="button-row">
      <button
        mat-stroked-button
        (click)="generateExcelExport()"
        type="button"
        [disabled]="exportingExcel"
        [dtOverlayProgress]="exportingExcel"
      >
        <mat-icon>download</mat-icon>
        <ng-container i18n>Auswahl exportieren</ng-container>
      </button>
      <button mat-raised-button color="primary" type="button" class="add-project-button" (click)="addProject()">
        <mat-icon>add</mat-icon>
        <ng-container i18n>Projekt hinzufügen</ng-container>
      </button>
    </div>
  </div>

  <table
    mat-table
    [dataSource]="items"
    matSort
    [matSortDisableClear]="true"
    [matSortActive]="sort.sortBy"
    [matSortDirection]="sort.sortDirection"
    (matSortChange)="onSortChange($event)"
  >
    <ng-container matColumnDef="token">
      <th mat-header-cell *matHeaderCellDef i18n>Token</th>
      <td mat-cell *matCellDef="let row">
        {{ row.token }}
      </td>
    </ng-container>
    <ng-container matColumnDef="finished">
      <th mat-header-cell *matHeaderCellDef i18n>Abgeschlossen</th>
      <td mat-cell *matCellDef="let row">
        <mat-icon>{{ row.finished ? 'done' : 'close' }}</mat-icon>
      </td>
    </ng-container>
    <ng-container matColumnDef="isOfficial">
      <th mat-header-cell *matHeaderCellDef i18n>Offiziell</th>
      <td mat-cell *matCellDef="let row">
        <mat-icon>{{ row.isOfficial ? 'done' : 'close' }}</mat-icon>
      </td>
    </ng-container>
    <ng-container matColumnDef="readonly">
      <th mat-header-cell *matHeaderCellDef i18n>Schreibgeschützt</th>
      <td mat-cell *matCellDef="let row">
        <mat-icon>{{ row.readonly ? 'done' : 'close' }}</mat-icon>
      </td>
    </ng-container>
    <ng-container matColumnDef="expiresAt">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>Läuft ab am</th>
      <td mat-cell *matCellDef="let row">{{ (row.expiresAt | date: 'medium') ?? '—' }}</td>
    </ng-container>
    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>Erstellt am</th>
      <td mat-cell *matCellDef="let row">{{ row.createdAt | date: 'medium' }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="editProject(row)"></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="displayedColumns.length" i18n>Keine KLUGentscheiden Projekte entsprechen dem Filter.</td>
    </tr>
  </table>

  <mat-paginator
    [pageSize]="page.pageSize"
    [pageIndex]="page.pageIndex"
    [length]="itemCount"
    [showFirstLastButtons]="true"
    (page)="onPageChange($event)"
  ></mat-paginator>
</dt-table-layout>
